import React, { useEffect } from "react";
import Navigation from "../../Components/Navigation/Navigation";
import Banner from "../../Components/Banner";
import Terms from "../../Assets/Images/Banner/t-c.jpg";
import "./FooterPages.css";
import GreenStamp from "../../Assets/Images/AboutUs/zen-stamp.svg";
import Footer from "../../Components/Navigation/Footer";
import PDFURL from "../../Documents/fullserviceandfee.pdf";

function TandC() {

  useEffect(() => {
    document.title = "Terms & Conditions | Zen Homes";
  }, []);

  return (
    <div className="tcContainer">
      <Navigation linkColor="black" submenuColor="black" menuIconColor="black"/>
      <Banner title="Terms & Conditions" backgroundImage={Terms}/>
      <div className="informationContainer">
        <div className="intro">
          <img src={GreenStamp} className="termsStamp" alt="Zen Stamp" />
          <h3>Sales</h3>
          <p>
            Our fees are on a percentage basis and calculated of the sale price,
            which is payable once the property has been completed, you are under
            no obligation to pay us anything prior to this as we operate on a no
            sale no fee basis.
          </p>
          <p>
          We also offer a flat fee service which is a set amount payable on
          completion which will not change based on the sale price and will
          remain the same payable upon completion.
          </p>
          
          <br />
          <h3>Lettings</h3>
          <p>
            
            <ul>
              <li>Full Management</li>
              <li>Let Only</li>
              <li>Rent Collection</li>
            </ul>
          </p>
          <div className="embedDocuments">
            <a
              href={PDFURL}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                textDecoration: "underline",
                color: "#177404",
                fontSize: "20px",
                marginLeft: "20px",
              }}
            >
              Full Service & Fee Comparison
            </a>
          </div>
          <br />
          <h3>Use of Images and Text</h3>
          <p>
            By accessing or using our website, you agree to the following terms
            and conditions regarding the use of images, text, and other content:
          </p>
          <ol>
            <li>
              <h4>Ownership of Content</h4>
              <p>
                All images, text, graphics, logos, icons, and other content
                displayed on this website are the property of Zen Homes, its
                affiliates, or third-party licensors. These materials are
                protected by copyright, trademark, and other intellectual
                property laws.
              </p>
            </li>
            <li>
              <h4>Permitted Use</h4>
              <p>You may view and access the content on this website solely for
                personal, non-commercial purposes, and in accordance with these
                Terms and Conditions. You are permitted to:
                <br />
                <br />
                
                <ul>
                  <li><strong>View and download </strong>images and text solely
                    for personal use, provided that you retain all copyright,
                    trademark, and other proprietary notices.</li>
                  <li> <strong>Share </strong>content on social media platforms,
                    provided that you give appropriate credit to Zen Homes and
                    do not alter or manipulate the content in any way.</li>
                </ul>
                </p>
            </li>
           
            <li>
              <h4>Prohibited Use</h4>
              <p>
                You are expressly prohibited from:
                <br />
                <br />
                <ul>
                  <li>
                    <strong>Using </strong>images, text, or other content from
                    this website for commercial purposes without obtaining prior
                    written consent from Zen Homes.
                  </li>
                  <li>
                    <strong>
                      Reproducing, modifying, distributing, or otherwise using{" "}
                    </strong>
                    any of the content for any public or commercial purposes
                    without obtaining prior written permission from Zen Homes.
                  </li>
                  <li>
                    <strong>Removing or altering </strong>any copyright,
                    trademark, or other proprietary notices contained within the
                    content.
                  </li>
                </ul>
              </p>
            </li>
            <li>
              <h4>Third-Party Content</h4>
              <p>
                Some images, text, or other materials on this website may be
                provided by third-party content providers. The use of such
                content is governed by the respective licensing agreements of
                the third-party providers. You must comply with the terms of
                these licences, and you are responsible for ensuring that your
                use of such content adheres to the applicable restrictions.
              </p>
            </li>
            <li>
              <h4>Licence for User-Generated Content</h4>
              <p>
                If you submit any content (including but not limited to text,
                images, reviews, or feedback) to our website, you grant Zen
                Homes a worldwide, royalty-free, non-exclusive licence to use,
                modify, reproduce, distribute, and display such content on the
                website and in other promotional materials. By submitting
                content, you represent and warrant that you have the necessary
                rights to grant this licence.
              </p>
            </li>
            <li>
              <h4>Changes to Terms</h4>
              <p>
                Zen Homes reserves the right to modify or update these Terms and
                Conditions at any time. We will notify users of any significant
                changes, and such changes will become effective immediately upon
                posting on this website. Your continued use of the website after
                such changes will constitute your acceptance of the modified
                terms.
              </p>
            </li>
          </ol>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default TandC;
